import { tabQueryParam, hiddenClass, searchInputQueryParam } from '../../../config.js';
import { selectors } from './elements.js';

export const getTabIdFromLink = (link) => {
    return link.getAttribute('href').split(`${tabQueryParam}=`)[1] ?? '';
};

export const updateTotal = (sections) => {
    const total = Object.values(sections)
        .map(Number)
        .reduce((sum, val) => sum + val, 0);

    const totalCountElement = document.querySelector(selectors.totalCountElement);
    if (totalCountElement) {
        const searchParams = new URL(window.location).searchParams;
        const hasSearch = !!searchParams.get(searchInputQueryParam);
        if (hasSearch) {
            totalCountElement.textContent = `${total} results`;
        } else {
            totalCountElement.textContent = 'Search';
        }
    }
};

export const hideAllClearButtons = () => {
    document.querySelectorAll(selectors.allClearXButtons).forEach(button => {
        button.classList.add(hiddenClass);
    });
};
